import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CloseTemplateRow } from "../organizationCloseTemplatesViewConfig";
import { useWorkspaceClientName } from "../useWorkspaceClientName";

export const CloseTemplateClientCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CloseTemplateRow, unknown>) => {
        const clientName = useWorkspaceClientName(row.original.workspaceId);

        return (
            <ViewTableCell>
                <span className="text-secondary">{clientName ?? "-"}</span>
            </ViewTableCell>
        );
    },
);

CloseTemplateClientCell.displayName = "CloseTemplateClientCell";
